import { onScrollEnd } from '../utils/debounce';
import { hasTouch } from '../utils/touch';
import { state } from './state';

// Videos whose native controls are switched on once they play.
const WITH_CONTROLS = ['al-kilani-vid-22', 'balata-vid-10', 'al-hashash-vid-12'];

const inViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top <= window.innerHeight && rect.bottom >= 0
        && rect.left <= window.innerWidth && rect.right >= 0;
};

const togglePlay = (video) => (video.paused ? video.play() : video.pause());

export default function videos() {
    // Non-looping videos hide their overlay (.hide-on-play siblings) while playing.
    document.querySelectorAll('video').forEach((video) => {
        const onPlayPause = (e) => {
            if (video.classList.contains('video-loop')) return;
            [...video.parentElement.children]
                .filter((el) => el !== video && el.classList.contains('hide-on-play'))
                .forEach((el) => el.classList.toggle('hide', e.type === 'play'));
            if (WITH_CONTROLS.includes(video.id)) {
                video.controls = true;
            }
        };
        video.addEventListener('play', onPlayPause);
        video.addEventListener('pause', onPlayPause);
    });

    // Play buttons (data-vid = video id): the button and the video toggle playback.
    document.querySelectorAll('.video-controls').forEach((button) => {
        const video = document.getElementById(button.dataset.vid);
        if (!video) return;
        [video, button].forEach((el) => el.addEventListener('click', () => togglePlay(video)));
    });

    // On touch devices looping videos don't autoplay: tapping toggles them.
    if (hasTouch()) {
        document.querySelectorAll('.video-loop').forEach((video) => {
            video.addEventListener('click', () => togglePlay(video));
        });
    }

    // Pause players scrolled out of view; looping ones autoplay in view (not on touch).
    onScrollEnd(() => {
        document.querySelectorAll('.videoplayer').forEach((video) => {
            if (!inViewport(video)) {
                // `paused` rather than "has data and is running": a video still
                // buffering would otherwise start playing off-screen.
                if (!video.paused) video.pause();
                return;
            }
            state.videoInView = video;
            if (!hasTouch() && video.classList.contains('video-loop') && video.paused) {
                video.play().catch(() => {});
            }
        });
    }, 100);
}
